import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { Status } from 'src/app/models/status/status.model';
import { StudyFile } from '../../../../../models/Study/study-file.model';
import { StudyStatus } from '../../../../../shared-new/enums/study-status.enum';
import { AuthService } from '../../../../../services/auth.service';

@Component({
  selector: 'app-review-table',
  templateUrl: './review-table.component.html',
  styleUrls: ['./review-table.component.scss'],
})
export class ReviewTableComponent implements OnInit, OnChanges {
  @Input() datasource: any[] = [];
  @Input() statuses: Status[] = [];
  @Input() showStamped: boolean = false;
  @Input() openButtonText: string = 'Items';
  @Input() headingText: string;
  @Input() isUserSaleEditor: boolean = false;
  @Input() isVetEditor: boolean = false;
  @Input() isViewerOnly: boolean = false;
  @Input() selectAll = false;
  @Output() selectionChanged = new EventEmitter<any>();
  @Output() openButtonClicked = new EventEmitter();
  @Output() manageButtonClicked = new EventEmitter();
  @Output() downloadButtonClicked = new EventEmitter();
  @Output() updateStatus = new EventEmitter();
  StudyStatus = StudyStatus;
  selection = new SelectionModel<any>(true, []); // Manage selected rows
  isSalesCompany: boolean = false;
  displayedColumns: string[] = [
    'fileName',
    'type',
    'details',
    'uploadedby',
    'uploadeddate',
    'status',
    'comment',
    'action',
  ];

  constructor(private authService: AuthService) {
    this.isSalesCompany = this.authService.IsSalesCompany();
  }

  ngOnInit(): void { }

  getStatusName(statusId: number): any {
    const selectedStatus = this.statuses.find(
      (status) => status.id === statusId
    );
    return selectedStatus ? selectedStatus.altName : '';
  }

  onChangeStatus($event: any, studyFile: StudyFile, studyFileIds: number[]): void {
    const statusId = $event?.target?.value;
    this.emitStatusUpdate(studyFile, studyFileIds, statusId);
  }

  emitStatusUpdate(studyFile: StudyFile, studyFileIds: number[], statusId: string): void {
    this.updateStatus.emit({ studyFile: studyFile, studyFileIds, statusId: parseInt(statusId) });
  }

  emitOpenButtonClicked(studyFileIds: number[]): void {
    this.openButtonClicked.emit(studyFileIds);
  }

  emitManageButtonClicked(studyFileIds: number[]): void {
    this.manageButtonClicked.emit(studyFileIds);
  }

  emitDownloadButtonClicked(studyFileIds: number[]) : void {
    this.downloadButtonClicked.emit(studyFileIds);
  }

  ngOnChanges() {
    // When parent toggles select all, update this table's selection
    if (this.selectAll) {
      this.selection.select(
        ...this.datasource.filter(
          element => element.originalStatus !== StudyStatus.Approved && element.originalStatus !== StudyStatus.Denied
        )
      );
    } else {
      this.selection.clear();
    }
    this.emitSelectionChanged();
  }

  toggleRow(row: any) {
    this.selection.toggle(row);
    this.emitSelectionChanged();
  }

  toggleAllRows() {
    if (this.selection.hasValue()) {
      this.selection.clear();
    } else {
      this.selection.select(
        ...this.datasource.filter(
          element => element.originalStatus !== StudyStatus.Approved && element.originalStatus !== StudyStatus.Denied
        )
      );
    }
    this.emitSelectionChanged();
  }

  isAllSelected() {
    if (this.isAllDisabled()) {
      return false;
    }
    const selectableItems = this.datasource.filter(
      element => element.originalStatus !== StudyStatus.Approved && element.originalStatus !== StudyStatus.Denied
    );
    return this.selection.selected.length === selectableItems.length;
  }

  isAllDisabled() {
    const selectableItems = this.datasource.filter(
      element => element.originalStatus == StudyStatus.Approved || element.originalStatus == StudyStatus.Denied
    );
    return this.datasource.length === selectableItems.length;
  }

  emitSelectionChanged() {
    const result = {
      selectedHorses: this.selection.selected,
      type: this.headingText,
      isAllSelected: this.isAllSelected()
    }
    this.selectionChanged.emit(result);
  }
}
